import { render } from "./OverlayPicture.vue?vue&type=template&id=7b3d4530&scoped=true"
import script from "./OverlayPicture.vue?vue&type=script&lang=js"
export * from "./OverlayPicture.vue?vue&type=script&lang=js"

import "./OverlayPicture.vue?vue&type=style&index=0&id=7b3d4530&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3d4530"]])

export default __exports__